import { render } from "./FormAddStockOpname.vue?vue&type=template&id=2b56ea7a"
import script from "./FormAddStockOpname.vue?vue&type=script&lang=js"
export * from "./FormAddStockOpname.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__